import { Link } from "react-router-dom"
import React from "react"

function Footer() {
	function track(label: string) {
		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "footer", link: label })
		} catch (e) {}
	}

	return (
		<footer
			className=" bg-[#A6B0EF] pt-12 "
			style={{ background: "radial-gradient(55.57% 79.57% at 50% 50%, #A6B0EF 0%, #7575CB 100%)" }}
		>
			<div className="relative pb-8 max-w-[1440px] mx-auto">
				<img
					src={"/images/share1.png"}
					alt="Share Image"
					className="absolute -left-4  sm:left-8 top-0 w-[123px] sm:w-[238px] -translate-y-[60%] sm:-translate-y-1/2 cursor-none"
				/>
				<img
					src={"/images/share2.png"}
					alt="Share Image"
					className="absolute -right-4 sm:right-8 bottom-0 w-[123px] sm:w-[238px] cursor-none"
					style={{ transform: "translateY(30%)" }}
				/>
				<div className="max-w-[732px] mx-auto relative z-10">
					<h3 className="h3 font-Fields text-[35px] sm:text-[70px] leading-[35px] sm:leading-[79px] text-white px-[90px] sm:px-0">
						Lust auf weitere spannende Neuigkeiten zu Intuition?
					</h3>
					<p className="text-center font-AcuminWide text-[15px] sm:text-[25px] pt-7">
						Folge uns auf Social media und <br />
						werde Teil unserer Community!
					</p>
					<div className="align-self-center mx-auto  pt-1  sm:pt-6 max-w-[220px] sm:max-w-[320px] justify-center self-center text-center">
						<a
							href="https://www.instagram.com/intuition_by_wilkinson_sword"
							target="_blank"
							className="inline-block pr-4 sm:pr-8 md:max-w-[116px] lg:pt-0"
							rel="noreferrer"
							onClick={() => track("Instagram")}
							aria-label="Besuche uns auf Instagram"
						>
							<svg
								className="w-[43px] sm:w-[83px]"
								width="83"
								height="83"
								viewBox="0 0 83 83"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M24.4815 0C10.9834 0 0 10.9834 0 24.4815V58.3759C0 71.874 10.9834 82.8574 24.4815 82.8574H58.3759C71.874 82.8574 82.8574 71.874 82.8574 58.3759V24.4815C82.8574 10.9834 71.874 0 58.3759 0H24.4815ZM24.4815 3.76715H58.3759C69.8364 3.76715 79.0902 13.021 79.0902 24.4815V58.3759C79.0902 69.8364 69.8364 79.0902 58.3759 79.0902H24.4815C13.021 79.0902 3.76715 69.8364 3.76715 58.3759V24.4815C3.76715 13.021 13.021 3.76715 24.4815 3.76715ZM64.0216 15.0686C61.9442 15.0686 60.2545 16.7484 60.2545 18.8357C60.2545 20.9131 61.9442 22.6029 64.0216 22.6029C66.109 22.6029 67.7888 20.9131 67.7888 18.8357C67.7888 16.7484 66.109 15.0686 64.0216 15.0686ZM41.4287 20.7143C30.008 20.7143 20.7143 30.008 20.7143 41.4287C20.7143 52.8494 30.008 62.143 41.4287 62.143C52.8494 62.143 62.143 52.8494 62.143 41.4287C62.143 30.008 52.8494 20.7143 41.4287 20.7143ZM41.4287 24.4815C50.8118 24.4815 58.3759 32.0456 58.3759 41.4287C58.3759 50.8118 50.8118 58.3759 41.4287 58.3759C32.0456 58.3759 24.4815 50.8118 24.4815 41.4287C24.4815 32.0456 32.0456 24.4815 41.4287 24.4815Z"
									fill="white"
								/>
							</svg>
						</a>
						<a
							href="https://wilkinsonsword.de/pages/frauen"
							target="_blank"
							className="inline-block pr-4 sm:pr-8 md:max-w-[116px] lg:pt-0"
							rel="noreferrer"
							onClick={() => track("Instagram")}
							aria-label="Besuche uns auf Instagram"
						>
							<svg
								className="w-[43px] sm:w-[82px]"
								width="82"
								height="79"
								viewBox="0 0 82 79"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clip-path="url(#clip0_35_678)">
									<mask
										id="mask0_35_678"
										maskUnits="userSpaceOnUse"
										x="0"
										y="0"
										width="82"
										height="79"
									>
										<path d="M82 0.0012207H0V78.999H82V0.0012207Z" fill="white" />
									</mask>
									<g mask="url(#mask0_35_678)">
										<path
											d="M58.0773 69.348C55.2999 71.1292 52.267 72.5421 49.0381 73.4927C51.4321 70.7181 53.4853 66.9588 55.0699 62.463L51.5258 54.3363C47.8368 53.8481 44.3183 53.5998 41.0383 53.5142V41.3626H54.8313C54.7802 43.2723 54.6695 45.1477 54.482 46.9888L58.1624 48.6073C58.4265 46.2695 58.5969 43.846 58.6566 41.3541H74.375C74.128 45.9698 73.0034 50.3457 71.1546 54.3277L74.6562 55.8691C76.9564 50.8681 78.2429 45.2933 78.2429 39.4273C78.2429 17.7618 60.7013 0.129639 39.1384 0.129639C17.5756 0.129639 0.0255127 17.7618 0.0255127 39.4359C0.0255127 61.1099 17.5756 78.7506 39.1384 78.7506C46.6526 78.7506 53.6727 76.6098 59.6363 72.9018L58.0858 69.3394L58.0773 69.348ZM69.0248 20.6048C72.1259 25.5545 74.0428 31.3263 74.3665 37.5176H58.6481C58.5373 32.5851 57.9921 27.9095 57.0805 23.6534C60.9142 22.9255 64.9099 21.9322 69.0163 20.6048M66.699 17.3165C63.0867 18.4297 59.5682 19.2861 56.1774 19.9198C54.4906 13.8654 52.0199 8.85579 49.0381 5.39616C56.0837 7.46851 62.2177 11.6989 66.699 17.3165ZM41.0468 4.26578C44.2757 5.23345 47.4109 8.59889 49.8815 13.8312C50.8527 15.8778 51.6791 18.1386 52.3777 20.5535C48.365 21.1358 44.5654 21.4355 41.0468 21.5297V4.26578ZM41.0468 25.3576C44.8465 25.2634 48.9614 24.9379 53.3149 24.2871C54.2009 28.4061 54.7291 32.8763 54.8399 37.5091H41.0468V25.349V25.3576ZM29.2303 5.38759C26.2144 8.88148 23.7352 13.9425 22.0484 20.0653C16.9026 19.1148 13.2307 17.9587 11.5268 17.3679C16.0081 11.716 22.1591 7.46851 29.2303 5.38759ZM9.23507 20.6134C10.2148 20.9988 14.466 22.5659 21.1453 23.8076C20.2593 28.0293 19.7226 32.645 19.6118 37.5176H3.89336C4.22562 31.3348 6.13398 25.5631 9.23507 20.6134ZM9.23507 58.2669C6.1425 53.3172 4.22562 47.5454 3.89336 41.3626H19.6033C19.714 46.2352 20.2508 50.8509 21.1368 55.0727C14.4575 56.3144 10.2148 57.8815 9.22655 58.2669M11.5268 61.5124C13.2222 60.9215 16.8941 59.7569 22.0484 58.8064C23.7352 64.9292 26.2144 69.9902 29.2303 73.4841C22.1591 71.4032 16.0081 67.1557 11.5268 61.5039M37.2216 74.6145C33.9927 73.6468 30.8575 70.2814 28.3869 65.0491C27.4071 62.9596 26.5552 60.6561 25.8481 58.1898C26.2826 58.1299 26.7256 58.0699 27.1771 58.01C30.0652 57.6503 33.4474 57.3763 37.2216 57.3249V74.6059V74.6145ZM37.2216 53.497C33.2089 53.5484 29.6137 53.8481 26.5637 54.2335C26.0014 54.302 25.4647 54.3791 24.928 54.4561C24.059 50.3799 23.5478 45.9526 23.437 41.3712H37.2301V53.5056L37.2216 53.497ZM37.2216 37.5176H23.4285C23.5393 32.9276 24.0504 28.5089 24.9194 24.4327C25.4562 24.5098 26.0014 24.5868 26.5552 24.6553C29.6137 25.0407 33.2004 25.3319 37.213 25.3832V37.5176H37.2216ZM37.2216 21.5468C33.4474 21.4954 30.0652 21.2214 27.1771 20.8617C26.7256 20.8018 26.2826 20.7419 25.8481 20.6819C26.5552 18.2156 27.3986 15.9121 28.3869 13.8226C30.8575 8.59032 33.9927 5.22489 37.2216 4.25722V21.5383V21.5468ZM41.0468 74.6145V57.3506C44.5654 57.4448 48.365 57.7359 52.3777 58.3268C51.6791 60.7417 50.8527 63.0025 49.8815 65.0491C47.4109 70.2814 44.2757 73.6468 41.0468 74.6145Z"
											fill="white"
										/>
										<path
											d="M81.8381 75.2396L78.311 78.7849C78.098 78.999 77.7572 78.999 77.5443 78.7849L67.1335 68.3203C67.1335 68.3203 67.0994 68.3118 67.0909 68.3203L63.6575 75.7877C63.4786 76.2244 62.8652 76.2415 62.6607 75.8134L50.5971 48.102C50.3756 47.6396 50.8612 47.1515 51.3213 47.3742L78.8903 59.5C79.3163 59.7055 79.3078 60.3221 78.8648 60.5019L71.4358 63.953C71.4358 63.953 71.4187 63.9787 71.4273 63.9958L81.8381 74.4603C82.0511 74.6744 82.0511 75.0255 81.8381 75.2396Z"
											fill="white"
										/>
									</g>
								</g>
								<defs>
									<clipPath id="clip0_35_678">
										<rect width="82" height="79" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</a>

						<a
							href="https://www.tiktok.com/@intuitionwilkinsonsword"
							className="inline-block"
							target="_blank"
							rel="noreferrer"
							onClick={() => track("TikTok")}
							aria-label="Besuche uns auf TikTok"
						>
							<svg
								className="w-[43px] sm:w-[80px]"
								width="80"
								height="80"
								viewBox="0 0 80 80"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M9.4129 0C4.23431 0 0 4.23431 0 9.4129V69.6674C0 74.846 4.23431 79.0803 9.4129 79.0803H69.6674C74.846 79.0803 79.0803 74.846 79.0803 69.6674V9.4129C79.0803 4.23431 74.846 0 69.6674 0H9.4129ZM9.4129 3.76715H69.6674C72.8183 3.76715 75.3131 6.26201 75.3131 9.4129V69.6674C75.3131 72.8183 72.8183 75.3131 69.6674 75.3131H9.4129C6.26201 75.3131 3.76715 72.8183 3.76715 69.6674V9.4129C3.76715 6.26201 6.26201 3.76715 9.4129 3.76715ZM41.5082 11.2915C40.4645 11.2915 39.6197 12.1364 39.6197 13.1701C39.6197 13.1701 39.5998 22.3544 39.5799 31.5586C39.57 36.1606 39.56 40.7627 39.5501 44.2317C39.5401 47.7006 39.5401 49.8874 39.5401 50.0762C39.5401 53.4955 36.439 56.2885 32.9004 56.2885C29.3917 56.2885 26.5887 53.4756 26.5887 49.9669C26.5887 46.4582 29.3917 43.6552 32.9004 43.6552C33.0197 43.6552 33.2583 43.6949 33.6658 43.7446C34.2025 43.8142 34.7393 43.6452 35.1369 43.2874C35.5444 42.9296 35.773 42.4127 35.773 41.876V33.964C35.773 32.97 34.9977 32.145 34.0137 32.0854C33.7155 32.0655 33.3477 32.0257 32.9004 32.0257C23.0104 32.0257 14.9593 40.0868 14.9593 49.9669C14.9593 59.8569 23.0104 67.9081 32.9004 67.9081C42.7805 67.9081 50.8416 59.8569 50.8416 49.9669V32.9302C53.575 35.1269 56.9943 36.5085 60.7614 36.5085C61.2783 36.5085 61.7653 36.4787 62.2325 36.439C63.1966 36.3495 63.9421 35.5344 63.9421 34.5604V25.7637C63.9421 24.7797 63.1768 23.9547 62.1927 23.8851C56.2687 23.4676 51.5572 18.8457 50.941 12.9813C50.8416 12.027 50.0265 11.2915 49.0624 11.2915H41.5082ZM43.3868 15.0587H47.6808C49.0425 21.271 53.903 26.0122 60.175 27.195V32.5923C56.1494 32.3836 52.6109 30.3757 50.5335 27.2149C50.0762 26.5191 49.2115 26.2011 48.4163 26.4396C47.6211 26.6782 47.0744 27.4137 47.0744 28.2486V49.9669C47.0744 57.8193 40.7428 64.1409 32.9004 64.1409C25.0481 64.1409 18.7264 57.8193 18.7264 49.9669C18.7264 42.4326 24.6008 36.4588 32.0058 35.9718V40.0769C26.8968 40.5441 22.8216 44.7386 22.8216 49.9669C22.8216 55.5132 27.3541 60.0458 32.9004 60.0458C38.417 60.0458 43.3073 55.712 43.3073 50.0762C43.3073 50.1657 43.3073 47.7006 43.3172 44.2317C43.3272 40.7727 43.3371 36.1606 43.347 31.5586C43.3669 23.2987 43.3769 16.6589 43.3868 15.0587Z"
									fill="white"
								/>
							</svg>
						</a>
					</div>
				</div>
			</div>
			<div className="py-[15px] sm:py-[50px] text-center bg-black">
				<Link
					to={"/faq"}
					className="block sm:inline px-4 text-white py-2 sm:py-0 text-[15px]"
					onClick={() => track("FAQ")}
				>
					FAQs
				</Link>

				<Link
					to={"/teilnahmebedingungen"}
					className="block sm:inline px-4 text-white py-2 sm:py-0 text-[15px]"
					onClick={() => track("Teilnahmebedingungen")}
				>
					Teilnahmebedingungen
				</Link>

				<Link
					to={"/kontakt"}
					className="block sm:inline px-4 text-white py-2 sm:py-0 text-[15px]"
					onClick={() => track("Kontakt")}
				>
					Kontakt
				</Link>
			</div>
		</footer>
	)
}

export default Footer
